export const showTooltip = (condition: boolean) =>
  condition ? {} : { visible: false }
